export default __webpack_public_path__ + "e7223fde15ab16a007478bc6ef4018a6.png";